import { Component, OnInit } from '@angular/core';
import { HeaderService, Header } from '../../common/header/header.service';
import { FooterService, Footer } from '../../common/footer/footer.service';
import { LoaderService, Loader } from '../../common/loader/loader.service';
import { AwsTrackingService } from '../../common/tracking/aws-tracking.service';
import { EventDetails } from 'app/common/tracking/aws-tracker';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from 'app/application/application.service';


@Component({
  selector: 'zest-error',
  templateUrl: './generic-error.component.html',
  styleUrls: ['./generic-error.component.scss']
})
export class GenericErrorComponent implements OnInit {

  // public state: string = undefined;

  constructor(
    private headerService: HeaderService,
    private footerService: FooterService,
    private loaderService: LoaderService,
    private awsTrackingService: AwsTrackingService,
    private router: Router,
    private applicationService: ApplicationService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.headerService.ShowHeaderSource.next(new Header(2, false, 0, false, '', false));
    this.footerService.ShowFooterSource.next(new Footer(false, false, false, false, false, true));
    this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
    const error = this.route.queryParams.subscribe(res => {
      return res.error;
    });
    const event = new EventDetails('Onboarding_Generic_Error_Page_Loaded', 'event');
    const props = {
      errorMessage: error,
      errorLocation: window.location.pathname,
    };
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props).subscribe();
    this.applicationService.sendDataToLogger('Generic Error Page Loaded', {
      errorMessage: error,
      errorLocation: window.location.pathname,
    }).subscribe();
  }
  retryClick() {
    const event = new EventDetails('Onboarding_Generic_Error_Cta_Clicked', 'event');
    this.awsTrackingService.sendDataToFunnel(event).subscribe();
    this.router.navigate(['/loggedinredirect']);
  }
}
